export const SHOPIFY_API_LIBRARY_VERSION = '13.0.0';
